import COLORS from "@app/colors";
import { Height } from "@mui/icons-material";
import { Components } from "@mui/material/styles/components";

const MuiCssBaseline: Components["MuiCssBaseline"] = {
  styleOverrides: {
    "*": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
    },
    '.MuiTableCell-root': {
      padding: '5px 10px !important',
      borderBottom: 'none !important'
    },
    '.MuiTableRow-root': {
      borderBottom: `1px solid ${COLORS.border} !important`
    },
    textarea: {
      height: '200px !important'
    }
  },
};

export default MuiCssBaseline;
